import { Box, Typography } from '@mui/material'
import { BarChart } from '@mui/x-charts/BarChart'

import StyledPaper from '/components/paper'

const ChartPanel = ({ title, description, dataset, xAxis, series, loading, height = 380, yAxis }) => (
  <StyledPaper>
    <div className='p-5'>
      <Typography variant='h5'>{title}</Typography>
      {description && <Typography variant='body2'>{description}</Typography>}
      <Box sx={{ height, width: '100%' }}>
        <BarChart
          dataset={dataset}
          xAxis={[xAxis]}
          series={series}
          loading={loading}
          yAxis={yAxis}
        />
      </Box>
    </div>
  </StyledPaper>
)

export default ChartPanel
